export enum BroadcastChannelMessageTypes {
  CART_CHANGES,
  SHOW_CHANGES,
  PING,
  PONG,
  BLANK_SCREEN,
  DISABLE_CUSTOMER_SCREEN,
  ENABLE_CUSTOMER_SCREEN,
  PAY_SEPARATELY_SELECTION_CHANGED,
  REBOOK_RESERVATION_CHANGED
}
